module.exports = __webpack_public_path__ + "static/media/step10.a2856ec0.png";